{
  "common": {
    "cancel": "Cancelar",
    "saveChanges": "Salvar Alterações"
  },
  "createUser": {
    "title": "Cadastrar novo aluno",
    "namePlaceholder": "Nome do aluno",
    "emailPlaceholder": "E-mail do aluno",
    "accessGroupPlaceholder": "Grupo de acesso",
    "noActiveGroups": "Nenhum grupo ativo",
    "groupCourses_one": "({{count}} curso)",
    "groupCourses_zero": "({{count}} cursos)",
    "groupCourses_other": "({{count}} cursos)",
    "password": "Senha",
    "passwordMode": {
      "emailTitle": "Enviar link por e-mail",
      "emailSubtitle": "O aluno define a própria senha",
      "manualTitle": "Definir senha manualmente",
      "manualSubtitle": "Você escolhe a senha do aluno"
    },
    "passwordPlaceholder": "Mínimo 8 caracteres",
    "submit": "Cadastrar",
    "validation": {
      "nameMin": "Nome deve ter pelo menos 2 caracteres",
      "emailInvalid": "E-mail inválido",
      "passwordMin": "Senha deve ter pelo menos 8 caracteres"
    },
    "toast": {
      "createdEmailSent": "Membro criado — e-mail de definição de senha enviado",
      "created": "Membro criado com sucesso!",
      "createError": "Erro ao criar membro."
    }
  },
  "roles": {
    "STUDENT": "Aluno",
    "INSTRUCTOR": "Instrutor",
    "ADMIN": "Admin",
    "SUPER_ADMIN": "Super Admin",
    "AFFILIATE": "Afiliado"
  },
  "statuses": {
    "ACTIVE": "Ativo",
    "INACTIVE": "Inativo",
    "BLOCKED": "Bloqueado",
    "SUSPENDED": "Suspenso",
    "PENDING_VERIFICATION": "Pendente"
  },
  "userEditDialog": {
    "title": "Editar Usuário",
    "description": "Edite as informações e permissões do usuário",
    "personalData": "Dados Pessoais",
    "name": "Nome",
    "namePlaceholder": "Nome completo",
    "email": "Email",
    "emailPlaceholder": "email@exemplo.com",
    "permissions": "Permissões",
    "role": "Função",
    "rolePlaceholder": "Selecione a permissão",
    "status": "Status",
    "statusPlaceholder": "Selecione o status",
    "updateError": "Erro ao atualizar usuário",
    "validation": {
      "nameMin": "Nome deve ter no mínimo 3 caracteres",
      "emailInvalid": "Email inválido"
    }
  },
  "enrollUser": {
    "title": "Matricular Usuário",
    "description": "Adicione um usuário ao grupo \"{{group}}\"",
    "successTitle": "Matrícula Realizada!",
    "successMessage": "{{name}} foi matriculado com sucesso.",
    "searchLabel": "Buscar Usuário *",
    "change": "Alterar",
    "searchPlaceholder": "Buscar por nome, email ou CPF...",
    "search": "Buscar",
    "noUsersFound": "Nenhum usuário encontrado",
    "expirationDate": "Data de Expiração",
    "optional": "(opcional)",
    "expirationHint": "Deixe em branco para usar as configurações do grupo",
    "group": "Grupo:",
    "productsIncluded_one": "{{count}} produto incluído",
    "productsIncluded_zero": "{{count}} produtos incluídos",
    "productsIncluded_other": "{{count}} produtos incluídos",
    "enrolling": "Matriculando...",
    "enroll": "Matricular",
    "enrollError": "Erro ao matricular usuário",
    "validation": {
      "userRequired": "Selecione um usuário"
    }
  },
  "time": {
    "never": "Nunca",
    "justNow": "Agora mesmo",
    "minutesAgo": "{{minutes}}min atrás",
    "hoursAgo": "{{hours}}h atrás",
    "daysAgo": "{{days}}d atrás"
  },
  "usersPage": {
    "title": "Membros",
    "registeredCount_one": "{{count}} membro cadastrado",
    "registeredCount_zero": "{{count}} membros cadastrados",
    "registeredCount_other": "{{count}} membros cadastrados",
    "searchPlaceholder": "Pesquise pelo nome, e-mail ou CPF",
    "createStudent": "Cadastrar aluno",
    "filters": {
      "title": "Filtros",
      "clearAll": "Limpar tudo",
      "status": "Situação",
      "allStatuses": "Todas",
      "accessGroup": "Grupo de Acesso",
      "allGroups": "Todos os grupos",
      "createdAt": "Data de cadastro",
      "from": "De",
      "to": "Até",
      "lastLogin": "Último acesso",
      "active": "Filtros ativos:",
      "chip": {
        "status": "Situação: {{value}}",
        "group": "Grupo: {{value}}",
        "createdAt": "Cadastro: {{from}} → {{to}}",
        "lastLogin": "Último acesso: {{from}} → {{to}}"
      }
    },
    "export": {
      "tooltip": "Exportar membros em CSV",
      "button": "Exportar",
      "generating": "Gerando CSV...",
      "empty": "Nenhum membro para exportar",
      "success_one": "CSV gerado — {{count}} membro",
      "success_zero": "CSV gerado — {{count}} membros",
      "success_other": "CSV gerado — {{count}} membros",
      "error": "Erro ao exportar",
      "fileName": "usuarios",
      "yes": "Sim",
      "no": "Não",
      "headers": {
        "id": "ID",
        "name": "Nome",
        "email": "Email",
        "phone": "Telefone",
        "cpf": "CPF",
        "role": "Função",
        "status": "Status",
        "emailVerified": "Email verificado",
        "courses": "Cursos",
        "certificates": "Certificados",
        "lastLogin": "Último login",
        "createdAt": "Cadastrado em"
      }
    },
    "table": {
      "member": "Membro",
      "role": "Papel",
      "status": "Status",
      "courses": "Cursos",
      "certificates": "Certificados",
      "lastLogin": "Último acesso",
      "actions": "Ações"
    },
    "actions": {
      "openMenu": "Abrir menu",
      "edit": "Editar membro",
      "generateDeepLink": "Gerar deep link",
      "sendPasswordReset": "Enviar email de definição de senha",
      "deactivate": "Inativar membro",
      "activate": "Ativar membro"
    },
    "toast": {
      "activated": "Membro ativado",
      "deactivated": "Membro inativado",
      "statusError": "Erro ao alterar status",
      "passwordResetSent": "Email de definição de senha enviado para {{email}}",
      "emailError": "Erro ao enviar email",
      "deepLinkError": "Erro ao gerar deep link"
    },
    "pagination": {
      "showing": "Mostrando <bold>{{from}}</bold> – <bold>{{to}}</bold> de <bold>{{total}}</bold> membros",
      "previous": "Anterior",
      "next": "Próxima"
    },
    "empty": {
      "title": "Nenhum membro encontrado",
      "filtered": "Tente outra busca ou limpe os filtros",
      "none": "Nenhum membro cadastrado"
    },
    "deepLink": {
      "title": "Deep Link",
      "accessLinkFor": "Link de acesso para <strong>{{name}}</strong>",
      "copiedToast": "Link copiado!",
      "copied": "Copiado!",
      "copy": "Copiar Link",
      "importantInfo": "Informações importantes:",
      "valid24h": "Válido por 24 horas",
      "singleUse": "Uso único - será invalidado após o primeiro acesso",
      "autoAuth": "O membro será autenticado automaticamente"
    }
  },
  "userEdit": {
    "backToMembers": "Voltar aos Membros",
    "pendingChanges": "Alterações pendentes",
    "avatar": {
      "invalidImage": "Selecione uma imagem válida",
      "tooLarge": "A imagem deve ter no máximo 5MB",
      "updated": "Foto atualizada — clique em Salvar para persistir",
      "uploadError": "Erro ao enviar imagem",
      "uploading": "Enviando…",
      "change": "Trocar foto"
    },
    "toast": {
      "updated": "Membro atualizado com sucesso",
      "updateError": "Erro ao atualizar membro"
    },
    "validation": {
      "nameMin": "Nome deve ter no mínimo 2 caracteres",
      "urlInvalid": "URL inválida",
      "phoneInvalid": "Número de telefone inválido",
      "cpfDigits": "CPF deve ter 11 dígitos"
    },
    "summary": {
      "memberId": "ID do Membro",
      "courses": "Cursos",
      "lessons": "Aulas",
      "certificatesShort": "Certif.",
      "totalXp": "XP Total",
      "createdAt": "Cadastrado em",
      "lastLogin": "Último login"
    },
    "tabs": {
      "overview": "Visão Geral",
      "overviewShort": "Geral",
      "profile": "Dados Pessoais",
      "profileShort": "Perfil",
      "progress": "Progresso",
      "gamification": "Gamificação",
      "gamificationShort": "XP",
      "surveys": "Pesquisas",
      "surveysShort": "Pesq.",
      "certificates": "Certificados",
      "certificatesShort": "Cert."
    },
    "overview": {
      "personalData": "Dados Pessoais",
      "fullName": "Nome completo",
      "email": "Email",
      "phone": "Telefone",
      "cpf": "CPF",
      "birthDate": "Data de Nascimento",
      "permissionsAndStatus": "Permissões e Status",
      "role": "Função",
      "status": "Status",
      "language": "Idioma"
    },
    "groups": {
      "title": "Grupos de Acesso",
      "selectedOfTotal": "<bold>{{selected}}</bold> de <bold>{{total}}</bold>",
      "pending": "Pendente",
      "hint": "Selecione os grupos para matricular o membro em todos os cursos do grupo.",
      "noActiveGroups": "Nenhum grupo de acesso ativo",
      "searchPlaceholder": "Buscar grupos...",
      "selectedCount_one": "{{count}} selecionado",
      "selectedCount_zero": "{{count}} selecionados",
      "selectedCount_other": "{{count}} selecionados",
      "clear": "Limpar",
      "noMatch": "Nenhum grupo corresponde ao filtro",
      "showing": "Mostrando {{shown}} de {{total}} grupos",
      "current": "Atual"
    },
    "access": {
      "title": "Termos e Acesso",
      "terms": "Termos de uso",
      "acceptance": "Aceite",
      "accepted": "Aceito",
      "pending": "Pendente",
      "acceptanceDate": "Data do aceite",
      "firstAccess": "Primeiro acesso",
      "date": "Data",
      "neverAccessed": "Nunca acessou",
      "ip": "IP",
      "location": "Local",
      "userAgent": "Navegador / Dispositivo",
      "lastAccess": "Último acesso",
      "termsHistory": "Histórico de aceites dos termos",
      "version": "Versão",
      "versionValue": "v{{version}}",
      "locationFull": "Localização"
    },
    "surveys": {
      "emptyTitle": "Nenhuma pesquisa respondida",
      "emptyDescription": "Este membro ainda não respondeu nenhuma pesquisa",
      "answered": "Respondidas",
      "answers": "Respostas",
      "latest": "Última",
      "surveyFallback": "Pesquisa",
      "answeredAt": "Respondida em {{date}}",
      "completed": "Concluída",
      "questionFallback": "Pergunta"
    },
    "profile": {
      "notProvided": "Não informado",
      "personalData": "Dados Pessoais",
      "name": "Nome",
      "email": "Email",
      "phone": "Telefone",
      "cpf": "CPF",
      "birthDate": "Data de nascimento",
      "gender": "Gênero",
      "educationAndExperience": "Formação e Experiência",
      "occupation": "Ocupação",
      "education": "Escolaridade",
      "experience": "Experiência",
      "bio": "Bio",
      "interestsAndSkills": "Interesses e Habilidades",
      "interests": "Áreas de interesse",
      "hobbies": "Hobbies",
      "skills": "Habilidades",
      "address": "Endereço",
      "country": "País",
      "zipCode": "CEP",
      "state": "Estado",
      "city": "Cidade",
      "neighborhood": "Bairro",
      "street": "Rua",
      "number": "Número",
      "complement": "Complemento",
      "customFields": "Campos Personalizados",
      "socialNetworks": "Redes Sociais",
      "website": "Website"
    },
    "progress": {
      "summary": "Resumo de Aprendizado",
      "enrollments": "Matrículas",
      "lessonsStarted": "Aulas iniciadas",
      "lessonsCompleted": "Aulas completas",
      "certificates": "Certificados",
      "completionRate": "Taxa de conclusão",
      "enrolledCourses": "Cursos matriculados ({{count}})",
      "noEnrollments": "Nenhuma matrícula registrada",
      "enrolledAt": "Matriculado em {{date}}",
      "courseCompletedAt": "Concluído em {{date}}",
      "recentLessons": "Últimas aulas ({{count}})",
      "noActivity": "Nenhuma atividade registrada",
      "lessonCompletedAt": "Concluída em {{date}}",
      "lastUpdatedAt": "Última atualização em {{date}}"
    },
    "gamification": {
      "totalXp": "XP Total",
      "level": "Nível {{level}}",
      "achievements": "Conquistas",
      "available": "Disponíveis",
      "completeness": "Completude",
      "achievementProgress": "Progresso de conquistas",
      "unlocked": "Conquistas desbloqueadas ({{count}})",
      "noneUnlocked": "Nenhuma conquista desbloqueada ainda",
      "locked": "A conquistar ({{count}})",
      "points": "{{points}} XP"
    }
  }
}
